import breakpointsJSON from './breakpoints.json'

export type Breakpoint = keyof typeof breakpointsJSON
export const breakpoints: { readonly [c in Breakpoint]: string } = breakpointsJSON
